function LeftBlogContent({data}){
 return(
     <>
          <div>
            <div className="post-main">
              <p className="post-date">
                Posted on{" "}
                {new Date(data?.blog?.created_at).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </p>
              <h1 className="post-title">{data?.blog?.name}</h1>
              <div className="sector_image">
                <div>
                  <img
                    src={data.blog?.media_1}
                    alt="Chair and Plants"
                    className="main-img"
                  />
                  <p className="img-credit">Credits : {data?.blog?.admin?.name}</p>
                </div>
              </div>
            </div>

            <p className="post-subtitle">
              {data?.blog?.other_desc_1}
            </p>

            <h3 className="post-subheading">
              {data?.blog?.other_head_1}
            </h3>
            <p className="post-text">
              {data.blog?.other_desc_2}
            </p>
            <p className="post-text">{data.blog?.other_head_2}</p>

            <img
              src={data?.blog?.media_2}
              alt="Chair and Plants"
              className="main-img_2_blog"
              style={{ marginBottom: '25px', width: '100%' }}
            />
            <ol className="how-to-list">
              {data?.blog?.content?.map((item, index) => (
                <li key={index}>
                  <p className="item-to-list">{item?.heading}</p>
                  <p className="item_track_des_blog">{item?.description}</p>
                </li>
              ))}
            </ol>

            {/* Youtube Iframe  */}
            
            <div className="youtube-video">
              <iframe
                width="100%"
                height="400"
                src={`${data.blog?.video}?autoplay=1&mute=1&playsinline=1`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
                style={{ width: "100%", height: "400" }}
              ></iframe>
            </div>

            <p className="post-text">
              {data.blog?.description}
            </p>

              {/* Social Media Content  */}

            <div className="connect-footer">
              <div className="social-icons-blog">
                <i className="fa-brands fa-facebook"></i>
                <i className="fa-brands fa-instagram"></i>
                <i className="fa-brands fa-youtube"></i>
              </div>
            </div>
          </div>
     </>
 )

}
export default LeftBlogContent;